<script setup lang="ts">
import type { SelectItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { SelectItem, SelectItemIndicator, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	SelectItemProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectItem
		v-bind="forwardedProps"
		:class="
			cn(
				'relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50',
				props.class
			)
		"
	>
		<span class="absolute right-2 flex size-3.5 items-center justify-center">
			<SelectItemIndicator>
				<IconMaterialSymbolsLightCheck class="size-5 text-primary" />
			</SelectItemIndicator>
		</span>

		<!-- Existe um erro relacionado a esse componente TypeError: Cannot read
		properties of null (reading 'insertBefore') */ -->
		<!-- <SelectItemText>
			<slot></slot>
		</SelectItemText> -->

		<slot />
	</SelectItem>
</template>
